import React, { FunctionComponent } from "react"

import Text from "components/Text/Text"

const SelectErrorMessage: FunctionComponent<React.PropsWithChildren<unknown>> = ({
    children
}) => {
    return (
        <div className="py-4 text-center color-red-50">
            <Text>{children}</Text>
        </div>
    )
}

export default SelectErrorMessage
